module.exports = __webpack_public_path__ + "static/img/project3.f2840da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project3.jpg
// module id = 744
// module chunks = 1